"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.standardTailId = exports.focusVisible = exports.FADE_TIME = void 0; // Fade in and out time (measurement in seconds)

var FADE_TIME = 0.3;
exports.FADE_TIME = FADE_TIME;
var focusVisible = '.focus-visible';
exports.focusVisible = focusVisible;
var standardTailId = 100347;
exports.standardTailId = standardTailId;